module.exports = __webpack_public_path__ + "static/media/qr-code.5c6c26f8.jpg";